module.exports = __webpack_public_path__ + "fonts/Roboto-Italic.de74c609.ttf";